import React from "react"
import Sceleton from "./Skeleton"

export default function SkeletonBox(props: any) {
    const {width = "100%", height = "300px", children} = props

    return (
        <Sceleton>
            {children}
            <div className={"skeleton-custom-box"} style={{width: width, height}}/>
        </Sceleton>
    )
};